/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentGenerateAiArticlesMutationRequest, ContentGenerateAiArticlesMutationResponse, ContentGenerateAiArticlesPathParams } from "../models/ContentGenerateAiArticles";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { contentGenerateAiArticles } from "../axios/contentGenerateAiArticles";
import { useMutation } from "@tanstack/react-query";

export const contentGenerateAiArticlesMutationKey = () => ["content-ai-api", { url: '/contents/:id/generate-ai-articles' }] as const

export type ContentGenerateAiArticlesMutationKey = ReturnType<typeof contentGenerateAiArticlesMutationKey>

/**
 * @summary Generate AI articles from media analysis
 * {@link /contents/:id/generate-ai-articles}
 */
export function useContentGenerateAiArticles<TContext>(options: 
{
  mutation?: UseMutationOptions<ContentGenerateAiArticlesMutationResponse, ResponseErrorConfig<Error>, {id: ContentGenerateAiArticlesPathParams["id"], data?: ContentGenerateAiArticlesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ContentGenerateAiArticlesMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? contentGenerateAiArticlesMutationKey()

  return useMutation<ContentGenerateAiArticlesMutationResponse, ResponseErrorConfig<Error>, {id: ContentGenerateAiArticlesPathParams["id"], data?: ContentGenerateAiArticlesMutationRequest}, TContext>({
    mutationFn: async({ id, data }) => {
      return contentGenerateAiArticles(id, data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}